<template>
  <div class="add-popup">
    <div class="panel-title">
      <span>学生姓名</span>
      <span>{{master.student_name}}</span>
    </div>
    <div class="input-item">
      <div class="label">亲属手机号</div>
      <input type="text" v-model="phone" placeholder="请输入亲属手机号" />
    </div>
    <div class="input-item" @click="ChoiceRela">
      <div class="label">亲属关系</div>
      <input type="text" placeholder="选择亲属关系" readonly :value="relation" />
      <img :src="IconRight" class="right-icon" />
    </div>
    <div class="btn-list">
      <Btn title="取消" type="hollow" width="2.2rem" @click="$emit('close')" />
      <Btn title="确认" width="2.2rem" @click="AddFamily" />
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        relation: '',
        phone: ''
      }
    },
    props: {
      master: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      ChoiceRela () {
        this.$ShowActionSheet([
          { value: '爸爸' },
          { value: '妈妈' },
          { value: '爷爷' },
          { value: '奶奶' },
          { value: '其他' }
        ]).then(res => {
          this.relation = res.selectItem.name
        })
      },
      AddFamily () {
        this.$Post('Common.addFamily', {
          cup_id: this.$route.query.id,
          phone: this.phone,
          kinship: this.$FilterValue('Family', this.relation)
        }).then(res => {
          this.$emit('refresh')
          this.Reset()
          this.$ShowToast(res.msg, { icon: 'success' })
        })
      },
      Reset () {
        this.phone = ''
        this.relation = ''
      }
    },
    computed: {
      ...SetImage(['IconRight'])
    }
  }
</script>

<style lang="less" scoped>
  .add-popup {
    .w(6.43rem);
    .p(.6rem .4rem .55rem);
    box-sizing: border-box;
    .panel-title {
      .flex-c();
      .fz(.3rem);
      .c(#666);
      .mb(.2rem);
      span + span {
        .fz(.36rem);
        .c(#333);
        font-weight: bold;
        .ml(.7rem);
      }
    }
    .input-item {
      .w();
      display: flex;
      align-items: center;
      .h(1rem);
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      .label {
        .w(1.83rem);
        .fz(.3rem);
        .c(#333);
      }
      input {
        flex: 1;
        .fz(.3rem);
      }
      .right-icon {
        .w(.12rem);
        .h(.2rem);
      }
    }
    .btn-list {
      .p(0 .2rem);
      display: flex;
      justify-content: space-between;
      .mt(.8rem);
    }
  }
</style>
